import { TrackingTransparencyService } from './trackingTransparency.service';

export default angular
  .module('sfMobile.services.trackingTransparency', [
    'sfMobile.services.platform',
  ])
  .service('trackingTransparency', TrackingTransparencyService).name;
